<template>
  <component
    :is="path ? 'router-link' : 'div'"
    :to="path"
    :class="[
      theme ? 'tabnav-button--theme-' + theme : null,
      { 'tabnav-button--horizontal': horizontal },
    ]"
    class="tabnav-button"
  >
    <div class="tabnav-button__label">
      {{ label }}
    </div>

    <ul class="tabnav-button__pictos">
      <li class="tabnav-button__picto tabnav-button__picto--top">
        <div :class="['tabnav-button__pic', pictoTop]" />
      </li>

      <li class="tabnav-button__picto tabnav-button__picto--bottom">
        <div :class="['tabnav-button__pic', pictoBottom]" />
      </li>
    </ul>
  </component>
</template>

<script>
export default {
  props: {
    label: { type: String, default: null },
    theme: { type: String, default: null },
    path: { type: String, default: null },
    pictoTop: { type: String, default: null },
    pictoBottom: { type: String, default: null },
    horizontal: { type: Boolean, default: false },
  },
};
</script>

<style lang="stylus">
.tabnav-button {
  position: relative;
  cursor: pointer;

  &--theme-green { background-color: $cl-green; }
  &--theme-purple { background-color: $cl-purple; }
  &--theme-orange { background-color: $cl-orange; }

  &--horizontal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
  }
}

.tabnav-button__pictos {
  position: absolute;
  bottom: 40px;
  width: 100%;
  padding: 0;
  margin: 0;

  .tabnav-button--horizontal & {
    position: static;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    width: auto;
  }
}

.tabnav-button__picto {
  position: relative;
  margin: 0 auto;
  width: 60px !important;
  height: @width;

  background-size: 100% !important;
  border-radius: @width;
  overflow: hidden;

  .tabnav-button--horizontal & {
    width: 40px !important;
    height: @width;
  }

  &:before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px

    border: 1px solid $cl-white;
    border-radius: 100%;
  }

  .tabnav-button--theme-green & { background-color: $cl-green; }
  .tabnav-button--theme-purple & { background-color: $cl-purple; }
  .tabnav-button--theme-orange & { background-color: $cl-orange; }

  &--top {
    transform: translateY(25%);

    .tabnav-button--horizontal & {
      transform: translateX(0);
    }
  }

  &--bottom {
    transform: translateY(0);
    transition: transform 0.25s ease-in-out 0s;

    .tabnav-button--horizontal & {
      transform: translateX(25%);
    }

    +pointer-device() {
      .tabnav-button:hover & {
        transform: translateY(-25%);
      }

      .tabnav-button--horizontal:hover & {
        transform: translateX(50%);
      }
    }
  }
}

.tabnav-button__pic {
  position: relative;
  z-index: 1;
  width: 100% !important;
  height: 100% !important;
  background-size: 100% !important;
}

.tabnav-button__label {
  @extend $typo-main-nav;
  position: absolute;
  top: 40px;
  right: 50%;

  color: $cl-white;
  white-space: nowrap;
  text-transform: uppercase;
  text-align: left;
  transform-origin: right center;
  transform: rotate(-90deg);

  .tabnav-button--horizontal & {
    position: static;
    transform: none;
  }
}
</style>
